import * as React from "react";
import type { SVGProps } from "react";
const SvgSudan = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1280 720" {...props}>
    <path
      d="M0 0h1280v240H0z"
      style={{
        fill: "#d21034",
      }}
    />
    <path
      d="M0 240h1280v240H0z"
      style={{
        fill: "#fff",
      }}
    />
    <path d="M0 480h1280v240H0z" />
    <path
      d="m0 0 426.67 360L0 720z"
      style={{
        fill: "#007229",
      }}
    />
  </svg>
);
export default SvgSudan;
